// A task step that is a handoff chain (checkpoints contract §7,
// `TaskRunStep.previousAttempts`): "Claude → GPT-5 · usage limit", with a
// link to each earlier run. The step's own fields are its latest run.

import { Link } from '@tanstack/react-router'
import type { TaskRunStep } from '@goblic/shared'
import { chainSummary } from '../lib/run-recovery'
import { shortId } from '../lib/format'

export function StepChain({ step }: { step: TaskRunStep }) {
  const previous = step.previousAttempts ?? []
  if (previous.length === 0) return null
  return (
    <p className="text-ink-3">
      <span>{chainSummary(previous, step.agentName ?? step.roleName ?? null)}</span>
      {' · earlier: '}
      {previous.map((attempt, index) => (
        <span key={attempt.runId}>
          {index > 0 ? ', ' : ''}
          <Link
            to="/runs/$runId"
            params={{ runId: attempt.runId }}
            className="link"
            title={`${attempt.agentName ?? 'Agent'}, attempt ${attempt.attempt}`}
          >
            {attempt.agentName ?? `run ${shortId(attempt.runId)}`}
          </Link>
        </span>
      ))}
    </p>
  )
}
